export const isRouteVisibleForSalesOrg = (route, salesOrg) => {
  const { hiddenFromSalesOrgs } = route;

  if (hiddenFromSalesOrgs === undefined) {
    return true;
  }

  if (!Array.isArray(hiddenFromSalesOrgs) || hiddenFromSalesOrgs.length === 0) {
    // eslint-disable-next-line no-console
    console.warn(
      `Route ${route.path ?? '(unknown)'}: hiddenFromSalesOrgs must be a non-empty array of sales org codes`
    );
    return true;
  }

  return !hiddenFromSalesOrgs.includes(salesOrg);
};
